import { store } from './store.js';
export function RotateLogo(){
	return{
		get active(){
			return store.showRotateLogo ?? false;
		},		
	}
}